import React from "react";
import View from "common/View";
import ListNTPServers from "./List";
import AddNTPServer from "./Add";
import NTPServersAdminHelp from "./Help";

const options = [
  {
    signal: "add-server",
    label: "Add Server",
  },
];

export const NTPServersAdmin = () =>
  <View
    title="NTP Servers"
    className="container-lg"
    Help={NTPServersAdminHelp}
    options={options}
  >
    <ListNTPServers />
    <AddNTPServer />
  </View>

export default NTPServersAdmin;
